import React from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme, alpha } from "@mui/material";

interface ImageViewerProps {
    open: boolean;
    onClose: () => void;
    imageUrl: string;
    altText?: string;
}

export function ImageViewer({ open, onClose, imageUrl, altText = "Attachment" }: ImageViewerProps) {
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            PaperProps={{
                sx: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    overflow: 'visible',
                },
            }}
            sx={{
                '& .MuiBackdrop-root': {
                    backgroundColor: alpha(theme.palette.grey[900], 0.85),
                },
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: '300px',
                    minHeight: '300px',
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                }}
            >
                {/* Image */}
                <Box
                    component="img"
                    src={imageUrl}
                    alt={altText}
                    sx={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain',
                        borderRadius: 2,
                    }}
                    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking image
                />

                {/* Close button - positioned on top-right of image */}
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: theme.palette.common.white,
                        bgcolor: alpha(theme.palette.grey[900], 0.7),
                        border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
                        '&:hover': {
                            bgcolor: alpha(theme.palette.grey[800], 0.9),
                            borderColor: alpha(theme.palette.common.white, 0.4),
                        },
                        zIndex: 1,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </Dialog>
    );
}
